import React, { useState } from 'react';
import { useAppDispatch } from '../../../store/store';
import { sendResetPasswordRequest } from '../../../store/slices/auth';
import { useNavigate } from 'react-router-dom';

import styles from './ForgotPassword.module.scss';
import Input from '../../../components/UI/Inputs/Input';
import PrimaryButtonV2 from '../../../components/UI/Buttons/PrimaryButtonV2';
import { toast } from 'react-toastify';
import { useTranslation } from '../../../hooks/useTranslations';

function ForgotPassword() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [email, setEmail] = useState<string>('');

  const handleSend = async () => {
    await dispatch(sendResetPasswordRequest(email));
    const error = localStorage.getItem('error');
    if (error === '401') {
      navigate('/web/forgot-password-otp', { state: { email: email } });
    } else {
      toast.error('Something went wrong.', {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    }
  };
  const { translations } = useTranslation();

  return (
    <div className={styles.container}>
      <div className={styles.forgotPasswordContent}>
        <div>
          <div className={styles.headerContainerMobile}>
            <div className={styles.leftArrow} onClick={() => navigate(-1)} />
            <div className={styles.title}>{translations('label.forgot_your_password?')}</div>
          </div>
        </div>
        <div className={styles.noWorries}>{translations('label.no_worries')}</div>
        <span className={styles.textHint}>{translations('label.verification_code_sent')}</span>
        <div className={styles.emailInput}>
          <Input
            placeholder={translations('label.e-mail_address')}
            label={translations('label.e-mail_address')}
            value={email}
            onChange={(e) => setEmail(e?.target?.value)}
            type={'text'}
            id={'email'}
            isSecure={false}
            textarea={false}
            errorText={''}
          />
        </div>

        <div className={styles.btnContainer}>
          <PrimaryButtonV2
            text={translations('action.confirm')}
            containerStyle={{
              width: '100%',
            }}
            buttonStyle={{
              width: '100%',
            }}
            disabled={email === ''}
            onClick={handleSend}
          />
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;
